import { useState } from 'react';
import { useHistory } from 'react-router';
import BasicButton from '../../components/BasicButton';
import LoadingSpinner from '../../components/LoadingSpinner';
import TabLayout from '../../components/TabLayout';
import { logout } from '../../misc/firebase';
import { useAuthUser } from '../../misc/lib/user';
import routes from '../../misc/routes';
import './AdminPage.scss';
import ArchiveAdminPanel from './ArchiveAdminPanel';
import ContactAdminPanel from './ContactAdminPanel';
import DocumentsAdminPanel from './DocumentsAdminPanel';
import GalleryAdminPanel from './GalleryAdminPanel';
import NewsAdminPanel from './NewsAdminPanel';
import UsersAdminPanel from "./UsersAdminPanel";

const AdminPage = () => {
  const [ user, loading ] = useAuthUser();
  const history = useHistory();
  const [ loggingOut, setLoggingOut ] = useState(false);

  return loading ? <LoadingSpinner /> : !user ? null : (
    <div className="adminpage-container">
      <div className="adminpage-header">
        <h1>Rendeszergazdai felület</h1>
        <h3 className="adminpage-user-basic-info">
          <b>{ user.displayName }</b> <span>({ user.email })</span>
        </h3>
        <BasicButton text="Kijelentkezés" type="warning" onClick={ () => {
          setLoggingOut(true);
          logout().then(() => {
            history.push(routes.home.path);
          }).catch((err) => {
            console.error(err);
          }).finally(() => {
            setLoggingOut(false);
          });
        } } disabled={ loggingOut } working={ loggingOut } />
      </div>
      <TabLayout
        user={ user }
        tabs={ [
          'Dokumentumok', 'Hírek', 'Archívum',
          'Galéria', 'Kapcsolat', 'Adminisztrátorok'
        ] }
        panels={ [
          <DocumentsAdminPanel />, <NewsAdminPanel />,
          <ArchiveAdminPanel />, <GalleryAdminPanel />,
          <ContactAdminPanel />, <UsersAdminPanel />
        ] }
      />
    </div>
  );
};

export default AdminPage;
